import { RootState } from 'handlers';

export const getState = (state: RootState) => state;
